import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { IMediaTranscoderRepository } from '../../../../domain/media-transcoder/media-transcoder.repository';
import {
  IPackagerViewModelApi,
  MediaTranscoderPackagerViewModel,
} from './packager.view-model';

@Component({
  selector: 'evrideo-packager-jobs',
  templateUrl: './packager.component.html',
  styleUrls: ['./packager.component.scss'],
})
export class MediaTranscoderPackagerJobsComponent implements OnInit {
  readonly reportLoadingMessage =
    'Retrieving Shaka Packager process log. Please wait.';

  vm: MediaTranscoderPackagerViewModel;

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _mediaTranscoderRepository: IMediaTranscoderRepository,
    private _ngxSmartModalService: NgxSmartModalService,
  ) {
    this.vm = new MediaTranscoderPackagerViewModel(<IPackagerViewModelApi>{
      updateDOM: () => {
        _changeDetectorRef.detectChanges();
      },
      getJobs: () => _mediaTranscoderRepository.getShakaPackagerJobs(),
      getProcessLog: (jobUid: string) =>
        _mediaTranscoderRepository.getShakaPackagerProcessLog(jobUid),
    });
  }

  async ngOnInit(): Promise<void> {
    await this.vm.refreshJobs();
  }

  openBulkCreateDialog(): void {
    this._ngxSmartModalService.getModal('packagerBulkCreateModal').open();
  }

  async onBulkCreateCompleted(): Promise<void> {
    await this.vm.refreshJobs();
    this._changeDetectorRef.detectChanges();
  }
}
